export const Mutation = {
  GET_VIEWPORT_DIMENSIONS: '↕ Captura de dimensões do viewport',
  FETCH_SOUNDS: '🔊 Baixando sons'
}
